<script setup lang="ts">
const { state, close } = useAlert()

const handleOk = () => {
  state.value.onOk?.()
  //state.value.isVisible = false
  close()
}
</script>

<template>
  <div v-if="state.isVisible" class="layer active">
    <div class="mask"></div>
    <div class="inner">
      <section class="alert">
        <main v-dompurify-html="state.message"></main>
        <footer>
          <div class="btnArea">
            <a class="active" @click="handleOk">확인</a>
          </div>
        </footer>
      </section>
    </div>
  </div>
</template>
